var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"event-date",class:{ sm: _vm.$mq === 'sm' },domProps:{"innerHTML":_vm._s(_vm.formatedDate)}})
}
var staticRenderFns = []

export { render, staticRenderFns }